const SET_APPS = (state, apps) => {
  state.apps = apps
}

const SET_ORIGINATION_COUNTRIES = (state, originationCountries) => {
  state.originationCountries = originationCountries
}

const SET_COUNTRIES = (state, countries) => {
  state.countries = countries
}

const SET_CALLING_CORRIDORS = (state, callingCorridors) => {
  state.callingCorridors = callingCorridors
}

export default {
  SET_APPS,
  SET_ORIGINATION_COUNTRIES,
  SET_COUNTRIES,
  SET_CALLING_CORRIDORS
}



// WEBPACK FOOTER //
// ./src/store/modules/competitor/mutations.js